import React, { useEffect } from "react";
import "style/ModalStyles.css";
const AlertModal = (props: any) => {
  useEffect(() => {
    document.body.style.cssText = `
          position: fixed; 
          top: -${window.scrollY}px;
          overflow-y: scroll;
          width: 100%;`;
    return () => {
      const scrollY = document.body.style.top;
      document.body.style.cssText = "";
      window.scrollTo(0, parseInt(scrollY || "0", 10) * -1);
    };
  }, []);

  return (
    <div className="modalBackground">
      <div className="modalContainer-msg">
        <div className="mtitleCloseBtn">
          <button
            onClick={() => {
              props.setOpenModal(false);
            }}
          >
            ✕
          </button>
        </div>
        <div className="mbody">
          {props.modalMsg.split("\n").map((line: any, index: any) => {
            return (
              <span key={index} id="font-SCD3">
                {line}
                <br></br>
              </span>
            );
          })}
        </div>
        <div className="mfooter">
          <button
            onClick={() => {
              props.setOpenModal(false);
              props.clickConfirm();
            }}
            style={{ marginRight: "5px" }}
            id="font-SCD4"
          >
            예
          </button>
          <button
            onClick={() => {
              props.setOpenModal(false);
            }}
            style={{ marginLeft: "5px" }}
            id="font-SCD4"
          >
            취소
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
